import React, { Component } from 'react';
import PropTypes from 'prop-types';


const _checkSelectedDate = (date, selectedMonth, textYear, selectedYear) => {
    if (textYear === selectedYear) {
        if (date.id === selectedMonth) {
            return true;
        }
    }

    return false;
};

/** Component to show an item of a table selector */
class TableSelectorItem extends Component {

    static propTypes = {
        value:        PropTypes.object.isRequired, // The value of this item, it will be passed in the events. It will be shown if children had not passed
        onClick:      PropTypes.func, // Listener for when the item is clicked
        selectedYear: PropTypes.number, // Selected year
        selectedDate: PropTypes.number // The selected date to show
    };
    static defaultProps = {
        selected: false
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {
        this.handleClick = this.handleClick.bind(this);
    }

    /**
     * Bubble the click event passing the value
     */
    handleClick() {
        const { onClick, value, selectedDate, selectedYear } = this.props;

        const pickedDate = new Date(selectedDate);
        const pickedMonth = pickedDate.getMonth();
        const pickedYear = pickedDate.getFullYear();

        if (value.id !== pickedMonth || selectedYear !== pickedYear) {
            onClick && onClick(value);
        }
    }

    render() {
        const { value, selectedYear, selectedDate } = this.props;
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();

        const selectedUserDate = new Date(selectedDate);
        const selectedMonth = selectedUserDate.getMonth();
        const selectedDateYear = selectedUserDate.getFullYear();

        const selected = _checkSelectedDate(value, selectedMonth, selectedYear, selectedDateYear);

        if (selectedYear !== currentYear) {
            return (
                <td className={`table-selector-item ${selected ? 'selected' : ''}`} onClick={this.handleClick}>
                    {value.text}
                </td>
            );
        } else if (selectedYear === currentYear) {
            if (value.id <= currentMonth) {
                return (
                    <td className={`table-selector-item ${selected ? 'selected' : ''}`} onClick={this.handleClick}>
                        {value.text}
                    </td>
                );
            }
        }

        return (
            <td className={'table-disable-item'}>
                {value.text}
            </td>
        );


    }
}


export default TableSelectorItem;



// WEBPACK FOOTER //
// ./src/components/ui/form/dates/lib/TableSelectorItem.jsx